export function isPromise(p) {
    return p !== null && typeof p === 'object' && typeof p.then === 'function';
}
//# sourceMappingURL=is-promise.util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/utils/is-promise.util.js
// module id = 805
// module chunks = 3